import { Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import Highcharts from 'highcharts';
import { ProgressReportHttpCallsService } from '../progress-report-http-calls.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
// Option 1: Default import
// import html2pdf from 'html2pdf.js';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


declare const $: any;
// import * as CanvasJS from 'canvasjs';

@Component({
  selector: 'app-progress-report-page',
  templateUrl: './progress-report-page.component.html',
  styleUrls: ['./progress-report-page.component.scss']
})
export class ProgressReportPageComponent implements OnInit {

  @ViewChild('chartSubjectWisePerformanceId', { static: true }) chartContainer!: ElementRef;
  @ViewChild('enrollnow') enrollnowModal!: TemplateRef<any>;
  jwt: any = ""
  admNo: any = localStorage.getItem('studentUniqueRefNo')
  scaitsWebServiceUrl: any = localStorage.getItem('url')

  chartOptions: any;
  chartoptions: Highcharts.Options = {}
  testTypeList: any[] = [];
  downloadDisplay = "none";
  btnTestCode_TestTypeList = "TestType"
  btnSubjectPerformance_TestTypeList = "TestType"
  btnTestMode_TestTypeList = "TestType"
  btnRank_TestTypeList = "TestType"
  btnExamPerformance_TestTypeList = "TestType"
  testTypeExamResultsList: any;
  dataToSend: any;
  btnTestCode_TestTypeList2: any;
  showTable: any;
  pdf: any;
  displayAdmNo: any;

  constructor(private service: ProgressReportHttpCallsService) { }
  // openModal() {
  //   this.modal.open(this.enrollnowModal, { centered: true, size: 'lg' })
  // }
  ngOnInit(): void {
    this.changetab("tab1");
  }

  latestResults() {

    this.progressReportOverlay(0);
    // const data = { "admNo": this.admNo };

    this.admNo = localStorage.getItem('studentUniqueRefNo')
    this.service.latestExamResult(this.jwt, this.scaitsWebServiceUrl, this.admNo)
      .subscribe({
        next: (res: any) => {
          this.progressReportOverlay(1);
          this.getBanners(res.groupName);
          if (res == null && !res.hasOwnProperty('studentExamDetails') && !res.hasOwnProperty('groupName')) {
            $("#dvMainProgressReportId").text('Student details are not found...');
            return false;
          }

          if ((res.groupName == 'BI.P.C'
            || res.groupName == 'BIPC')
            && (res.groupName == 'M.P.C'
              || res.groupName == 'M.P.Cs'
              || res.groupName == 'MPC')) {
            $("#dvMainProgressReportId").text('Student details are not found...');
            return false;
          }

          if (res.hasOwnProperty('studentExamDetails')) {
            var examResults = res.studentExamDetails;
            this.btnTestCode_TestTypeList = examResults.testType
            this.btnTestCode_TestTypeList2 = examResults.testType
            this.btnSubjectPerformance_TestTypeList = examResults.testType
            this.btnTestMode_TestTypeList = examResults.testType
            this.btnRank_TestTypeList = examResults.testType
            this.btnExamPerformance_TestTypeList = examResults.testType
            this.setPDFProgressReportDetails(res);
            this.setRankDetails(examResults);
            this.setSubjectWisePerformanceColumnChart(examResults);
            this.setTestCodeWiseExamResults(res);
            if (res.hasOwnProperty('testModeWisePerformance')) {
              var testModeWisePerformance = res.testModeWisePerformance;
              $("#testTypeId3").text('OverAll View');
              this.setTestModeWisePerformance(testModeWisePerformance);
            }
            if (res.hasOwnProperty('examWisePerformance')) {
              var examWisePerformance = res.examWisePerformance;
              $("#testTypeId4").text('OverAll View');
              this.setExamWisePerformance(examWisePerformance);
            }
            if (res.hasOwnProperty('testTypeList')) {
              var testTypeList = res.testTypeList;
              this.testTypeList = testTypeList;
              this.setTestTypeList(testTypeList);
            }
            if (res.hasOwnProperty('testCodeList')) {
              var testCodeList = res.testCodeList;
              this.setTestCodeList(testCodeList);
            }
            return true;
          }
          else {
            $("#dvMainProgressReportId").text('Exam results data not found...');
            return false;
          }
          
        },
        error: (error) => {
          this.handleError(error);
        }
      });
  }

 setTestCodeList(testCodeList: any) {
    var optionsAsString = "";
    $('#dropdownTestCodeListId')
      .find('option')
      .remove()
      .end()
      .append('<option value="Select Test">Select Test</option>')
      .val('whatever');
    if (testCodeList.length > 0) {
      for (let index = 0; index < testCodeList.length; index++) {
        var examDate = new Date(testCodeList[index].dateOfTest);
        var dd = String(examDate.getDate()).padStart(2, '0');
        var mm = String(examDate.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = examDate.getFullYear();
        var examDateFormat = dd + '-' + mm + '-' + yyyy;
        optionsAsString += "<option value='" + testCodeList[index].testCode + "'>" + testCodeList[index].testCode + " --- " + examDateFormat + " </option>";
      }
      $('#dropdownTestCodeListId').append(optionsAsString);
      this.getTestCodeExamResults(testCodeList[0].testCode);
      $('#dropdownTestCodeListId').val(testCodeList[0].testCode);
    }
  }
  onTestCodeChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const testCode = target.value;
    this.getTestCodeExamResults(testCode);
  }
  getTestCodeExamResults(testCode: any) {
    this.progressReportOverlay(0);
    const data = { admNo: this.admNo, testCode: testCode }
    this.service.testCodeWiseResults(this.jwt, this.scaitsWebServiceUrl, data).subscribe({
      next: (latestExamResult) => {
        this.progressReportOverlay(1);
        this.setTestCodeWiseExamResults(latestExamResult);
      },
      error: (error) => {
        this.progressReportOverlay(1);
        alert('Student details are not found due to server error...');
      }
    });


  }

  setTestTypeList(jsonObjTestTypes: any) {
    this.testTypeList = jsonObjTestTypes;
    // console.log(jsonObjTestTypes)
  }
  onTestTypeClick(testType: string, action: string) {
    switch (action) {
      case 'rank':
        this.loadTestTypeWiseRankDetails(testType);
        break;
      case 'subjectPerformance':
        this.loadTestTypeWiseSubjectPerformance(testType);

        break;
      case 'testMode':
        this.loadTestTypeWiseTestModePerformance(testType);

        break;
      case 'examPerformance':
        this.loadTestTypeWiseExamPerformance(testType);

        break;
      case 'testCode':
        this.loadTestTypeAndTestCodeList(testType);

        break;
    }
  }
  loadTestTypeWiseSubjectPerformance(testType: string) {
    const data = {
      admNo: this.admNo,
      testType: testType
    }
    this.btnSubjectPerformance_TestTypeList = testType
    this.service.loadTestTypeWiseSubjectPerformance(this.jwt, this.scaitsWebServiceUrl, data).subscribe((res: any) => {
      this.progressReportOverlay(1);
      if (res.hasOwnProperty('studentExamDetails')) {
        var examResults = res.studentExamDetails;
        this.setSubjectWisePerformanceColumnChart(examResults);
      }
    },
      error => {
        this.progressReportOverlay(1);
        $("#dvMainProgressReportId").text('Student details are not found due to server error...');
      }
    );
  }
  loadTestTypeWiseTestModePerformance(testType: string) {
    const data = {
      admNo: this.admNo,
      testType: testType
    }
    this.btnTestMode_TestTypeList = testType
    this.service.loadTestTypeWiseTestModePerformance(this.jwt, this.scaitsWebServiceUrl, data).subscribe((res: any) => {
      this.progressReportOverlay(1);
      if (res.hasOwnProperty('testModeWisePerformance')) {
        var testModeWisePerformance = res.testModeWisePerformance;
        this.setTestModeWisePerformance(testModeWisePerformance);
      }
    },
      error => {
        this.progressReportOverlay(1);
        $("#dvMainProgressReportId").text('Student details are not found due to server error...');
      }
    );
  }

  loadTestTypeWiseExamPerformance(testType: string) {
    const data = {
      admNo: this.admNo,
      testType: testType
    }
    this.btnExamPerformance_TestTypeList = testType
    this.service.loadTestTypeWiseExamPerfornamce(this.jwt, this.scaitsWebServiceUrl, data).subscribe((res: any) => {
      this.progressReportOverlay(1);
      if (res.hasOwnProperty('examWisePerformance')) {
        var examWisePerformance = res.examWisePerformance;
        this.setExamWisePerformance(examWisePerformance);
      }
    },
      error => {
        this.progressReportOverlay(1);
        $("#dvMainProgressReportId").text('Student details are not found due to server error...');
      }
    );
  }

  loadTestTypeWiseRankDetails(testtype: any) {
    const data = {
      admNo: this.admNo,
      testType: testtype
    }
    this.btnRank_TestTypeList = testtype;
    this.service.loadTestTypeWiseRankDetails(this.jwt, this.scaitsWebServiceUrl, data).subscribe((res: any) => {
      this.progressReportOverlay(1);
      if (res.hasOwnProperty('studentExamDetails')) {
        var examResults = res.studentExamDetails;
        this.setRankDetails(examResults);
      }
    },
      error => {
        this.progressReportOverlay(1);
        $("#dvMainProgressReportId").text('Student details are not found due to server error...');
      }
    );

  }
  loadTestTypeAndTestCodeList(testType: any) {

    const data = {
      admNo: this.admNo,
      testType: testType
    }

    this.btnTestCode_TestTypeList = testType
    this.service.loadTestTypeAndTestCodeList(this.jwt, this.scaitsWebServiceUrl, data).subscribe((response: any) => {
      this.progressReportOverlay(1);
      if (response.hasOwnProperty('testCodeList')) {
        var testCodeList = response.testCodeList;
        this.setTestCodeList(testCodeList);
      }
    },
      error => {
        this.progressReportOverlay(1);
        $("#dvMainProgressReportId").text('Student details are not found due to server error...');
      }
    );
  }

  setTestModeWisePerformance(jsonObjTestModeWisePerformance: any) {
    const testModeWisePerformance = [];
    for (var keyTestMode in jsonObjTestModeWisePerformance) {
      if (jsonObjTestModeWisePerformance.hasOwnProperty(keyTestMode)) {
        testModeWisePerformance.push({ indexLabel: "{y}", y: jsonObjTestModeWisePerformance[keyTestMode].testModeAvg, label: jsonObjTestModeWisePerformance[keyTestMode].testMode });
      }
    }
    this.chartOptions = {

      chart: {
        type: 'column'
      },
      title: {
        text: '' // No title
      },
      xAxis: {
        title: {
          text: 'Test Mode'
        },
        categories: testModeWisePerformance.map(point => point.label) // Assuming `testModeWisePerformance` is an array of objects with `label` property
      },
      yAxis: {
        title: {
          text: 'Performance (%)'
        },
        min: 0,
        max: 100,
        tickInterval: 20,
      },
      plotOptions: {
        column: {
          pointWidth: 80
        }
      },
      series: [{
        name: 'Performance',
        showInLegend: false,
        data: testModeWisePerformance.map(point => point.y) // Assuming `testModeWisePerformance` is an array of objects with `y` property
      }]
    }
    Highcharts.chart('chartContainerTestModeId', this.chartOptions);
  }


  setExamWisePerformance(jsonObjStudentExamsList: any) {
    var examWisePerformance = [];
    var categories = [];
    for (let index = 0; index < jsonObjStudentExamsList.length; index++) {
      var examDate = new Date(jsonObjStudentExamsList[index].examYear, jsonObjStudentExamsList[index].examMonth, jsonObjStudentExamsList[index].examDay);

      var dd = String(examDate.getDate()).padStart(2, '0');
      var mm = String(examDate.getMonth()).padStart(2, '0'); //January is 0!
      var yyyy = examDate.getFullYear();

      var examDateFormat = dd + '/' + mm + '/' + yyyy;
      categories[index] = examDateFormat;
      //examWisePerformance[index] = jsonObjStudentExamsList[index].testAvg ;
      examWisePerformance.push({ name: jsonObjStudentExamsList[index].testCode + " -- " + examDateFormat, y: jsonObjStudentExamsList[index].testAvg });
    }

    // create the chart
    this.chartOptions = {
      chart: {
        type: 'line'
      },
      title: {
        text: ''
      },
      exporting: { enabled: false },
      xAxis: {
        categories: categories,
        title: {
          text: 'Exam Date'
        },
        labels: {
          rotation: -45,
          align: 'right',
          style: {
            fontSize: '10px',
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Marks (%)'
        }
      },
      tooltip: {
        pointFormat: '{point.y}'
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            color: '#000',
            align: 'right',
            style: {
              fontSize: '10px',
              fontFamily: 'Roboto',
              textOutline: false
            }
          }
        }
      },
      series: [{
        data: examWisePerformance
      }]

    };
    Highcharts.chart('container', this.chartOptions);
  }





  setTestCodeWiseExamResults(examResults: any) {
    $("#examResultsMathsId").css("display", "none");
    $("#examResultsPhyId").css("display", "none");
    $("#examResultsChemId").css("display", "none");
    $("#examResultsBotId").css("display", "none");
    $("#examResultsZooId").css("display", "none");

    // Subject Wise Marks
    $("#mathsMarksId").text('-');
    $("#phyMarksId").text('-');
    $("#chemMarksId").text('-');
    $("#botMarksId").text('-');
    $("#zooMarksId").text('-');

    // Subject Wise Perc
    $("#mathsPercId").text('-');
    $("#phyPercId").text('-');
    $("#chemPercId").text('-');
    $("#botPercId").text('-');
    $("#zooPercId").text('-');

    // Subject Wise ranks
    $("#mathsRankId").text('-');
    $("#phyRankId").text('-');
    $("#chemRankId").text('-');
    $("#botRankId").text('-');
    $("#zooRankId").text('-');


    // Topper Score
    $("#mathsTopperScoreId").text('-');
    $("#phyTopperScoreId").text('-');
    $("#chemTopperScoreId").text('-');
    $("#botTopperScoreId").text('-');
    $("#zooTopperScoreId").text('-');

    // Topper Score
    $("#mathsTopperScoreId").text('-');
    $("#phyTopperScoreId").text('-');
    $("#chemTopperScoreId").text('-');
    $("#botTopperScoreId").text('-');
    $("#zooTopperScoreId").text('-');


    // Topper Perc
    $("#mathsTopperPercId").text('-');
    $("#phyTopperPercId").text('-');
    $("#chemTopperPercId").text('-');
    $("#botTopperPercId").text('-');
    $("#zooTopperPercId").text('-');


    // Subject Wise Campus Rank
    $("#mathsCampusRankId").text('-');
    $("#phyCampusRankId").text('-');
    $("#chemCampusRankId").text('-');
    $("#botCampusRankId").text('-');
    $("#zooCampusRankId").text('-');


    // Subject Wise State Rank
    $("#mathsStateRankId").text('-');
    $("#phyStateRankId").text('-');
    $("#chemStateRankId").text('-');
    $("#botStateRankId").text('-');
    $("#zooStateRankId").text('-');

    var jsonObjExamResults;
    if (examResults.hasOwnProperty('studentExamDetails')) {
      $("#dvTestCodeWiseExamResultId").show();

      jsonObjExamResults = examResults.studentExamDetails;
      $("#testTypeId6").text(this.titleCase(jsonObjExamResults.testType));
      $("#examTitleNameId").text("Test Name : " + jsonObjExamResults.testCode + ' - ' + this.convertDateToStringFormat(new Date(jsonObjExamResults.dateOfTest)));
      $("#examTotalMarksId").text("Total Marks : " + jsonObjExamResults.total + "/" + jsonObjExamResults.totalMaxMarks);


      if (jsonObjExamResults.hasOwnProperty('maths') ) {
        $("#mathsMarksId").text(jsonObjExamResults.maths);
        if (jsonObjExamResults.hasOwnProperty('mathsMaxMarks')) {
          $("#mathsMarksId").text(jsonObjExamResults.maths + "/" + jsonObjExamResults.mathsMaxMarks);
          $("#mathsPercId").text("(" + Math.round((jsonObjExamResults.maths * 100 / jsonObjExamResults.mathsMaxMarks) * 100) / 100 + "%)");
        }
        $("#examResultsMathsId").css("display", "block");
        $("#examResultsBotId").css("display", "none");
        $("#examResultsZooId").css("display", "none");
      }
      if (jsonObjExamResults.hasOwnProperty('physics') ) {
        $("#examResultsPhyId").css("display", "block");
        $("#phyMarksId").text(jsonObjExamResults.physics);
        if (jsonObjExamResults.hasOwnProperty('phyMaxMarks')) {
          $("#phyMarksId").text(jsonObjExamResults.physics + "/" + jsonObjExamResults.phyMaxMarks);
          $("#phyPercId").text("(" + Math.round((jsonObjExamResults.physics * 100 / jsonObjExamResults.phyMaxMarks) * 100) / 100 + "%)");
        }
      }
      if (jsonObjExamResults.hasOwnProperty('chemistry')) {
        $("#examResultsChemId").css("display", "block");
        $("#chemMarksId").text(jsonObjExamResults.chemistry);
        if (jsonObjExamResults.hasOwnProperty('chemMaxMarks')) {
          $("#chemMarksId").text(jsonObjExamResults.chemistry + "/" + jsonObjExamResults.chemMaxMarks);
          $("#chemPercId").text("(" + Math.round((jsonObjExamResults.chemistry * 100 / jsonObjExamResults.chemMaxMarks) * 100) / 100 + "%)");
        }
      }
      if (jsonObjExamResults.hasOwnProperty('botany') ) {
        $("#examResultsBotId").css("display", "block");
        $("#botMarksId").text(jsonObjExamResults.botany);
        if (jsonObjExamResults.hasOwnProperty('botMaxMarks')) {
          $("#botMarksId").text(jsonObjExamResults.botany + "/" + jsonObjExamResults.botMaxMarks);
          $("#botPercId").text("(" + Math.round((jsonObjExamResults.botany * 100 / jsonObjExamResults.botMaxMarks) * 100) / 100 + "%)");
        }
      }

      if (jsonObjExamResults.hasOwnProperty('zoology')) {
        $("#examResultsZooId").css("display", "block");
        $("#zooMarksId").text(jsonObjExamResults.zoology);
        if (jsonObjExamResults.hasOwnProperty('zooMaxMarks')) {
          $("#zooMarksId").text(jsonObjExamResults.zoology + "/" + jsonObjExamResults.zooMaxMarks);
          $("#zooPercId").text("(" + Math.round((jsonObjExamResults.zoology * 100 / jsonObjExamResults.zooMaxMarks) * 100) / 100 + "%)");
        }
      }
      if (jsonObjExamResults.hasOwnProperty('mathsRank')) {
        $("#mathsRankId").text(jsonObjExamResults.mathsRank);
      }
      if (jsonObjExamResults.hasOwnProperty('physicsRank')) {
        $("#phyRankId").text(jsonObjExamResults.physicsRank);
      }
      if (jsonObjExamResults.hasOwnProperty('chemistryRank')) {
        $("#chemRankId").text(jsonObjExamResults.chemistryRank);
      }
      if (jsonObjExamResults.hasOwnProperty('botanyRank')) {
        $("#botRankId").text(jsonObjExamResults.botanyRank);
      }
      if (jsonObjExamResults.hasOwnProperty('zoologyRank')) {
        $("#zooRankId").text(jsonObjExamResults.zoologyRank);
      }

      // Subject Wise  Topper Score

      if (examResults.hasOwnProperty('topperMaths')) {
        var topperMaths = examResults.topperMaths;
        if (topperMaths.hasOwnProperty('mathsMaxMarks')) {
          $("#mathsTopperScoreId").text(topperMaths.maths + "/" + topperMaths.mathsMaxMarks);
        }
        else {
          $("#mathsTopperScoreId").text(topperMaths.maths);
        }
      }
      if (examResults.hasOwnProperty('topperPhysics')) {
        var topperPhysics = examResults.topperPhysics;
        if (topperPhysics.hasOwnProperty('phyMaxMarks')) {
          $("#phyTopperScoreId").text(topperPhysics.physics + "/" + topperPhysics.phyMaxMarks);
        }
        else {
          $("#phyTopperScoreId").text(topperPhysics.physics);
        }
      }
      if (examResults.hasOwnProperty('topperChemistry')) {
        var topperChemistry = examResults.topperChemistry;
        if (topperChemistry.hasOwnProperty('chemMaxMarks')) {
          $("#chemTopperScoreId").text(topperChemistry.chemistry + "/" + topperChemistry.chemMaxMarks);
        }
        else {
          $("#chemTopperScoreId").text(topperChemistry.chemistry);
        }
      }
      if (examResults.hasOwnProperty('topperBotany')) {
        var topperBotany = examResults.topperBotany;
        if (topperBotany.hasOwnProperty('botMaxMarks')) {
          $("#botTopperScoreId").text(topperBotany.botany + "/" + topperBotany.botMaxMarks);
        }
        else {
          $("#botTopperScoreId").text(topperBotany.botany);
        }
      }
      if (examResults.hasOwnProperty('topperZoology')) {
        var topperZoology = examResults.topperZoology;
        if (topperZoology.hasOwnProperty('zooMaxMarks')) {
          $("#zooTopperScoreId").text(topperZoology.zoology + "/" + topperZoology.zooMaxMarks);
        }
        else {
          $("#zooTopperScoreId").text(topperZoology.zoology);
        }
      }


      // Subject Wise Topper Perc

      if (examResults.hasOwnProperty('mathsAvgScore')) {
        var mathsAvgScore = examResults.mathsAvgScore;
        $("#mathsTopperPercId").text(Math.round((mathsAvgScore * 100)) / 100);
      }
      if (examResults.hasOwnProperty('phyAvgScore')) {
        var phyAvgScore = examResults.phyAvgScore;
        $("#phyTopperPercId").text(Math.round((phyAvgScore * 100)) / 100);
      }
      if (examResults.hasOwnProperty('chemAvgScore')) {
        var chemAvgScore = examResults.chemAvgScore;
        $("#chemTopperPercId").text(Math.round((chemAvgScore * 100)) / 100);
      }
      if (examResults.hasOwnProperty('botAvgScore')) {
        var botAvgScore = examResults.botAvgScore;
        $("#botTopperPercId").text(Math.round((botAvgScore * 100)) / 100);
      }
      if (examResults.hasOwnProperty('zooAvgScore')) {
        var zooAvgScore = examResults.zooAvgScore;
        $("#zooTopperPercId").text(Math.round((zooAvgScore * 100)) / 100);
      }



      // Subject Wise Campus Rank

      if (jsonObjExamResults.hasOwnProperty('cmpMathsRank')) {
        $("#mathsCampusRankId").text(jsonObjExamResults.cmpMathsRank);
      }
      if (jsonObjExamResults.hasOwnProperty('cmpPhyRank')) {
        $("#phyCampusRankId").text(jsonObjExamResults.cmpPhyRank);
      }
      if (jsonObjExamResults.hasOwnProperty('cmpChemRank')) {
        $("#chemCampusRankId").text(jsonObjExamResults.cmpChemRank);
      }
      if (jsonObjExamResults.hasOwnProperty('cmpBotRank')) {
        $("#botCampusRankId").text(jsonObjExamResults.cmpBotRank);
      }
      if (jsonObjExamResults.hasOwnProperty('cmpZooRank')) {
        $("#zooCampusRankId").text(jsonObjExamResults.cmpZooRank);
      }


      // Subject Wise State Rank


      if (jsonObjExamResults.hasOwnProperty('stateMathsRank')) {
        $("#mathsStateRankId").text(jsonObjExamResults.stateMathsRank);
      }
      if (jsonObjExamResults.hasOwnProperty('statePhyRank')) {
        $("#phyStateRankId").text(jsonObjExamResults.statePhyRank);
      }
      if (jsonObjExamResults.hasOwnProperty('stateChemRank')) {
        $("#chemStateRankId").text(jsonObjExamResults.stateChemRank);
      }
      if (jsonObjExamResults.hasOwnProperty('stateBotRank')) {
        $("#botStateRankId").text(jsonObjExamResults.stateBotRank);
      }
      if (jsonObjExamResults.hasOwnProperty('stateZooRank')) {
        $("#zooStateRankId").text(jsonObjExamResults.stateZooRank);
      }
    }
    else {
      $("#dvTestCodeWiseExamResultId").hide();
    }

  }

  handleError(error: any): void {
    this.progressReportOverlay(1);
    const errorMessage = 'Student details are not found due to server error...';
    // Update the UI to show the error message
    document.getElementById('dvMainProgressReportId')!.innerText = errorMessage;

  }
  // setSubjectWisePerformance(jsonObjExamResults: any): any {

  //   var dvChartSubjectWisePerformanceId = document.getElementById("chartSubjectWisePerformanceId");
  //   $("#testNameId2").text(jsonObjExamResults.testCode + ' - ' + this.convertDateToStringFormat(new Date(jsonObjExamResults.dateOfTest)));
  //   $("#btnSubjectPerformance_TestTypeListId").text(this.titleCase(jsonObjExamResults.testType));
  //   if (jsonObjExamResults.hasOwnProperty('group')) {
  //     const jsonSubjectWiseMarks = [];
  //     if (jsonObjExamResults.group == 'MPC' && jsonObjExamResults.hasOwnProperty('mathsMaxMarks')
  //       && jsonObjExamResults.hasOwnProperty('phyMaxMarks') && jsonObjExamResults.hasOwnProperty('chemMaxMarks')) {
  //       if (jsonObjExamResults.maths > 0)
  //         jsonSubjectWiseMarks.push({ y: jsonObjExamResults.maths * 100 / jsonObjExamResults.mathsMaxMarks, name: "Maths" });
  //       if (jsonObjExamResults.physics > 0)
  //         jsonSubjectWiseMarks.push({ y: jsonObjExamResults.physics * 100 / jsonObjExamResults.phyMaxMarks, name: "Physics" });
  //       if (jsonObjExamResults.chemistry > 0)
  //         jsonSubjectWiseMarks.push({ y: jsonObjExamResults.chemistry * 100 / jsonObjExamResults.chemMaxMarks, name: "Chemistry" });
  //     }
  //     else if (jsonObjExamResults.group == 'BIPC' && jsonObjExamResults.hasOwnProperty('botMaxMarks') && jsonObjExamResults.hasOwnProperty('zooMaxMarks')
  //       && jsonObjExamResults.hasOwnProperty('phyMaxMarks') && jsonObjExamResults.hasOwnProperty('chemMaxMarks')) {
  //       jsonSubjectWiseMarks.push({ y: jsonObjExamResults.botany * 100 / jsonObjExamResults.botMaxMarks, name: "Botany" });
  //       jsonSubjectWiseMarks.push({ y: jsonObjExamResults.zoology * 100 / jsonObjExamResults.zooMaxMarks, name: "Zoology" });
  //       jsonSubjectWiseMarks.push({ y: jsonObjExamResults.physics * 100 / jsonObjExamResults.phyMaxMarks, name: "Physics" });
  //       jsonSubjectWiseMarks.push({ y: jsonObjExamResults.chemistry * 100 / jsonObjExamResults.chemMaxMarks, name: "Chemistry" });
  //     }
  //     else if (jsonObjExamResults.hasOwnProperty('gkEnglish')) {
  //       jsonSubjectWiseMarks.push({ y: jsonObjExamResults.gkEnglish, name: "GK_English" });
  //     }
  //     else {
  //       dvChartSubjectWisePerformanceId!.innerHTML = "There is a problem while loading data. We resolve this shortly...";
  //       return false;
  //     }

  //     //  Pie chart script starts  
  //     var chart1 = new CanvasJS.Chart("chartSubjectWisePerformanceId", {
  //       exportEnabled: true,
  //       animationEnabled: true,
  //       title: {
  //         text: ""
  //       },
  //       legend: {
  //         cursor: "pointer",
  //         // itemclick: explodePie
  //       },
  //       data: [{
  //         type: "pie",
  //         showInLegend: true,
  //         toolTipContent: "{name}: <strong>{y}%</strong>",
  //         indexLabel: "{name} - {y}%",
  //         dataPoints: jsonSubjectWiseMarks
  //       }]
  //     });
  //     chart1.render();
  //   }
  //   else {

  //     dvChartSubjectWisePerformanceId!.innerHTML = "There is a problem while loading data. We resolve this shortly...";
  //     return false;
  //   }
  // }
  print() {
    const element = document.getElementById('element-to-print');
    if (element) {
      const options = {
        filename: 'myfile.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 1.2, letterRendering: true },
        jsPDF: { unit: 'pt', format: 'legal', orientation: 'portrait', compressPDF: true },
        pagebreak: { after: 'row', mode: ['avoid-all', 'css', 'legacy'] },
        // Ensure that margin is a tuple with exactly four numbers
        margin: [0, 15, 15, 15] as [number, number, number, number] // Cast to tuple type
      };

      // Create the PDF from the HTML element
    //   html2pdf()
    //     .from(element)
    //     .set(options)
    //     .save()
    //     .then(() => {
    //       console.log('PDF generated successfully!');
    //     })
    //     .catch((error) => {
    //       console.error('Error generating PDF:', error);
    //     });
    // } else {
    //   console.error('Element with id "element-to-print" not found.');
    }
  }

  modelPopupClose() {
    // this.modal.dismissAll();
  }
  download() {
    this.service.getPdf(this.admNo).subscribe({
      next: (blob: Blob) => {
        const fileName = `ProgressReport_${this.displayAdmNo}.pdf`;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url); // Clean up
      },
      error: (error) => {
        console.error('Error downloading PDF:', error);
      },
    });
    
  }
  
  setSubjectWisePerformanceColumnChart(jsonObjExamResults: any): any {
    var dvChartSubjectWisePerformanceId = document.getElementById("chartSubjectWisePerformanceId");
    $("#testNameId2").text(jsonObjExamResults.testCode + ' - ' + this.convertDateToStringFormat(new Date(jsonObjExamResults.dateOfTest)));
    $("#btnSubjectPerformance_TestTypeListId").text(jsonObjExamResults.testType);
    if (jsonObjExamResults.hasOwnProperty('group')) {
      let jsonSubjectWiseMarks = [];
      var mathsObj = [];
      var phyObj = [];
      var chemObj = [];
      var botObj = [];
      var zooObj = [];
      if (jsonObjExamResults.group == 'MPC' && jsonObjExamResults.hasOwnProperty('mathsMaxMarks')
        && jsonObjExamResults.hasOwnProperty('phyMaxMarks') && jsonObjExamResults.hasOwnProperty('chemMaxMarks')) {
        mathsObj.push(Math.round((jsonObjExamResults.maths * 100 / jsonObjExamResults.mathsMaxMarks) * 100) / 100);
        phyObj.push(Math.round((jsonObjExamResults.physics * 100 / jsonObjExamResults.phyMaxMarks) * 100) / 100);
        chemObj.push(Math.round((jsonObjExamResults.chemistry * 100 / jsonObjExamResults.chemMaxMarks) * 100) / 100);
        jsonSubjectWiseMarks.push({ name: 'Maths', data: mathsObj });
        jsonSubjectWiseMarks.push({ name: 'Physics', data: phyObj });
        jsonSubjectWiseMarks.push({ name: 'Chemistry', data: chemObj });
        this.chartOptions = {
          chart: {
            type: 'column'
          },
          title: {
            text: ''
          },
          yAxis: {
            title: {
              text: 'Marks (%)'
            }
          },
          plotOptions: {
            column: {
              dataLabels: {
                enabled: true,
                color: '#000',
                align: 'right',
                style: {
                  fontSize: '10px',
                  fontFamily: 'Roboto',
                  textOutline: false
                }
              }
            }
          },
          exporting: {
            enabled: false
          },
          series: jsonSubjectWiseMarks
        };
        Highcharts.chart('chartSubjectWisePerformanceId', this.chartOptions);

      }
      else if (jsonObjExamResults.group == 'BIPC' && jsonObjExamResults.hasOwnProperty('botMaxMarks') && jsonObjExamResults.hasOwnProperty('zooMaxMarks')
        && jsonObjExamResults.hasOwnProperty('phyMaxMarks') && jsonObjExamResults.hasOwnProperty('chemMaxMarks')) {
        botObj.push(Math.round((jsonObjExamResults.botany * 100 / jsonObjExamResults.botMaxMarks) * 100) / 100);
        zooObj.push(Math.round((jsonObjExamResults.zoology * 100 / jsonObjExamResults.zooMaxMarks) * 100) / 100);
        phyObj.push(Math.round((jsonObjExamResults.physics * 100 / jsonObjExamResults.phyMaxMarks) * 100) / 100);
        chemObj.push(Math.round((jsonObjExamResults.chemistry * 100 / jsonObjExamResults.chemMaxMarks) * 100) / 100);
        jsonSubjectWiseMarks.push({ data: botObj, name: "Botany" });
        jsonSubjectWiseMarks.push({ data: zooObj, name: "Zoology" });
        jsonSubjectWiseMarks.push({ data: phyObj, name: "Physics" });
        jsonSubjectWiseMarks.push({ data: chemObj, name: "Chemistry" });
        this.chartOptions = {
          chart: {
            type: 'column'
          },
          title: {
            text: ''
          },
          yAxis: {
            title: {
              text: 'Marks (%)'
            }
          },
          plotOptions: {
            column: {
              dataLabels: {
                enabled: true,
                color: '#000',
                align: 'right',
                style: {
                  fontSize: '10px',
                  fontFamily: 'Roboto',
                  textOutline: false
                }
              }
            }
          },
          exporting: {
            enabled: false
          },
          series: jsonSubjectWiseMarks
        };
        Highcharts.chart('chartSubjectWisePerformanceId', this.chartOptions);

      }
      else {
        dvChartSubjectWisePerformanceId!.innerHTML = "There is a problem while loading data. We resolve this shortly...";
        return false;
      }

    }
    else {

      dvChartSubjectWisePerformanceId!.innerHTML = "There is a problem while loading data. We resolve this shortly...";
      return false;
    }
  }





  setPDFProgressReportDetails(jsonObjExamResults: any) {
    if (jsonObjExamResults.hasOwnProperty('classWiseTestResults')) {
      if (jsonObjExamResults.hasOwnProperty('admNo')) {
        $("#popUpAdmNoId").text(jsonObjExamResults.admNo);
        this.displayAdmNo=jsonObjExamResults.admNo;
      }
      if (jsonObjExamResults.hasOwnProperty('sectionName')) {
        $("#popUpSectionId").text(jsonObjExamResults.sectionName);
      }
      if (jsonObjExamResults.hasOwnProperty('campusName')) {
        $("#popUpCampusId").text(jsonObjExamResults.campusName);
      }
      if (jsonObjExamResults.hasOwnProperty('studenName')) {
        $("#popUpStudentNameId").text(jsonObjExamResults.studenName);
      }
      if (jsonObjExamResults.hasOwnProperty('fatherName')) {
        $("#popUpFatherNameId").text(jsonObjExamResults.fatherName);
      }
      $("#dvTestWiseMarksId").html("");
      $("#dvTestWiseMarksPDFId").html("");
      
      var tableCount = 0;
      var tbMarksTable = null;
      var tbMarksTableRows = [];
      if (jsonObjExamResults.groupName == 'M.P.C' || jsonObjExamResults.groupName == 'M.P.Cs' || jsonObjExamResults.groupName == 'MPC') {
        $("#imgHeaderId").attr('src', '../../../../assets/image/MPC.jpg');
        $("#imgFooterId").attr('src', '../../../../assets/image/MPC.jpg');
        if (jsonObjExamResults.hasOwnProperty('classWiseTestResults')) {
          var classWiseTestResults = jsonObjExamResults.classWiseTestResults;

          if (classWiseTestResults.length > 0) {
            tbMarksTable = this.createMPCMarksTableHeader(tableCount);
            for (let index = 0; index < classWiseTestResults.length; index++) {
              var resultsBody = "";
              var testResultObj = classWiseTestResults[index];
              var examDateFormat = "-";
              if (testResultObj.hasOwnProperty('testCode')) {
                var examDate = new Date(testResultObj.dateOfTest);
                var dd = String(examDate.getDate()).padStart(2, '0');
                var mm = String(examDate.getMonth() + 1).padStart(2, '0');
                var yyyy = examDate.getFullYear();
                examDateFormat = dd + '-' + mm + '-' + yyyy;
              }
              var mathsMaxMarks = testResultObj.hasOwnProperty('mathsMaxMarks') ? "/" + testResultObj.mathsMaxMarks : "";
              var phyMaxMarks = testResultObj.hasOwnProperty('phyMaxMarks') ? "/" + testResultObj.phyMaxMarks : "";
              var chemMaxMarks = testResultObj.hasOwnProperty('chemMaxMarks') ? "/" + testResultObj.chemMaxMarks : "";
              var totalMaxMarks = testResultObj.hasOwnProperty('totalMaxMarks') ? "/" + testResultObj.totalMaxMarks : "";
              resultsBody += "<tr class='txt_align'>";
              resultsBody += "<td colspan='2'>" + (testResultObj.hasOwnProperty('testCode') ? testResultObj.testCode + "</br>" + examDateFormat : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('maths') ? "" + testResultObj.maths + mathsMaxMarks : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('physics') ? "" + testResultObj.physics + phyMaxMarks : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('chemistry') ? "" + testResultObj.chemistry + chemMaxMarks : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('total') ? "" + testResultObj.total + totalMaxMarks : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('allIndiaRank') ? "" + testResultObj.allIndiaRank : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('stateRank') ? "" + testResultObj.stateRank : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('prjectedRank') ? "" + testResultObj.prjectedRank : "-") + "</td></tr>";
              tbMarksTableRows[index] = resultsBody;
              $(tbMarksTable).append(resultsBody);
            }
          
            $("#dvTestWiseMarksId").append(tbMarksTable);
            tbMarksTable = this.createMPCMarksTableHeader(tableCount);
            for (let index = 0; index < tbMarksTableRows.length; index++) {
              tableCount++;
              if (index % 10 == 0)
                tbMarksTable = this.createMPCMarksTableHeader(tableCount);
              $(tbMarksTable).append(tbMarksTableRows[index]);
              $("#dvTestWiseMarksPDFId").append("<div>");
              $("#dvTestWiseMarksPDFId").append(tbMarksTable);
              $("#dvTestWiseMarksPDFId").append("<div class='html2pdf__page-break'></div>");
              $("#dvTestWiseMarksPDFId").append("</div>");
            }
          }
        }
      }
      if (jsonObjExamResults.groupName == 'BI.P.C' || jsonObjExamResults.groupName == 'BIPC') {
        $("#imgHeaderId").attr('src', '../../../../assets/image/BIPC.jpg');
        $("#imgFooterId").attr('src', '../../../../assets/image/BIPC.jpg');
        if (jsonObjExamResults.hasOwnProperty('classWiseTestResults')) {
          var classWiseTestResults = jsonObjExamResults.classWiseTestResults;
          if (classWiseTestResults.length > 0) {
            var tableCount = 0;
            var tbMarksTable = null;
            var tbMarksTableRows = [];
            tbMarksTable = this.createBIPCMarksTableHeader(tableCount);
            for (let index = 0; index < classWiseTestResults.length; index++) {
              var resultsBody = "";
              var testResultObj = classWiseTestResults[index];
              var examDateFormat = "-";
              if (testResultObj.hasOwnProperty('testCode')) {
                var examDate = new Date(testResultObj.dateOfTest);
                var dd = String(examDate.getDate()).padStart(2, '0');
                var mm = String(examDate.getMonth() + 1).padStart(2, '0');
                var yyyy = examDate.getFullYear();
                examDateFormat = dd + '-' + mm + '-' + yyyy;
              }

              var botMaxMarks = testResultObj.hasOwnProperty('botMaxMarks') ? "/" + testResultObj.botMaxMarks : "";
              var zooMaxMarks = testResultObj.hasOwnProperty('zooMaxMarks') ? "/" + testResultObj.zooMaxMarks : "";
              var phyMaxMarks = testResultObj.hasOwnProperty('phyMaxMarks') ? "/" + testResultObj.phyMaxMarks : "";
              var chemMaxMarks = testResultObj.hasOwnProperty('chemMaxMarks') ? "/" + testResultObj.chemMaxMarks : "";
              var totalMaxMarks = testResultObj.hasOwnProperty('totalMaxMarks') ? "/" + testResultObj.totalMaxMarks : "";

              resultsBody += "<tr class='txt_align'>";
              resultsBody += "<td colspan='2'>" + (testResultObj.hasOwnProperty('testCode') ? testResultObj.testCode + "</br>" + examDateFormat : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('physics') ? "" + testResultObj.physics + phyMaxMarks : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('chemistry') ? "" + testResultObj.chemistry + chemMaxMarks : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('botany') ? "" + testResultObj.botany + botMaxMarks : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('zoology') ? "" + testResultObj.zoology + zooMaxMarks : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('total') ? "" + testResultObj.total + totalMaxMarks : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('allIndiaRank') ? "" + testResultObj.allIndiaRank : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('stateRank') ? "" + testResultObj.stateRank : "-") + "</td>";
              resultsBody += "<td>" + (testResultObj.hasOwnProperty('prjectedRank') ? "" + testResultObj.prjectedRank : "-") + "</td></tr>";
              tbMarksTableRows[index] = resultsBody;
              $(tbMarksTable).append(resultsBody);
            }
            $("#dvTestWiseMarksId").append(tbMarksTable);
            tbMarksTable = this.createBIPCMarksTableHeader(tableCount);
            for (let index = 0; index < tbMarksTableRows.length; index++) {
              tableCount++;
              if (index % 10 == 0)
                tbMarksTable = this.createBIPCMarksTableHeader(tableCount);
              $(tbMarksTable).append(tbMarksTableRows[index]);
              $("#dvTestWiseMarksPDFId").append("<div>");
              $("#dvTestWiseMarksPDFId").append(tbMarksTable);
              $("#dvTestWiseMarksPDFId").append("<div class='html2pdf__page-break'></div>");
              $("#dvTestWiseMarksPDFId").append("</div>");
            }
          }
        }
      }
    }
  }

  progressReportOverlay(val: any) {
    if (val == 0) {
      $("#dvProgressReportContainerId").hide();
      $("#loadingImgDiv").show();
    } else {
      $("#dvProgressReportContainerId").show();
      $("#loadingImgDiv").hide();
    }
  }



  xValues: any = [0, 50, 100, 150, 200];
  yValues: any = [0, 100, 200];


  openNav() {
    document.getElementById("mySidenav")!.style.width = "250px";
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
  }

  closeNav() {
    document.getElementById("mySidenav")!.style.width = "0";
    document.body.style.backgroundColor = "white";
  }
  createMPCMarksTableHeader(tableId: any) {
    var tbMarksTable = document.createElement('table');
    $(tbMarksTable).attr('id', 'tbTestWiseMarksId' + tableId);
    $(tbMarksTable).addClass('table table-bordered keeptogether myStyle');
    var resultsHeader = "<tr>";
    resultsHeader += "<th colspan='2'  class='table_hd table-danger txt_align'>Exam Name & Date</th> ";
    resultsHeader += "<th class='table_hd table-danger txt_align' >Maths</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align' >Physics</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align' >Chemistry</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align' >Total</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align'>AIR</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align'>State Rank</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align' >Projected Rank</th></tr>";
    $(tbMarksTable).append(resultsHeader);
    return tbMarksTable;
  }

  createBIPCMarksTableHeader(tableId: any) {
    var tbMarksTable = document.createElement('table');
    $(tbMarksTable).attr('id', 'tbTestWiseMarksId' + tableId);
    $(tbMarksTable).addClass('table table-bordered keeptogether myStyle');
    var resultsHeader = "<tr>";
    resultsHeader += "<th colspan='2'  class='table_hd table-danger txt_align'>Exam Name & Date</th> ";
    resultsHeader += "<th class='table_hd table-danger txt_align' >Physics</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align' >Chemistry</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align' >Botany</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align' >Zoology</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align' >Total</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align'>AIR</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align'>State Rank</th>";
    resultsHeader += "<th class='table_hd table-danger txt_align' >Projected Rank</th></tr>";
    $(tbMarksTable).append(resultsHeader);
    return tbMarksTable;
  }

  setRankDetails(jsonObjExamResults: any) {
    $("#testNameId1").text(jsonObjExamResults.testCode + ' - ' + this.convertDateToStringFormat(new Date(jsonObjExamResults.dateOfTest)));
    $("#testTypeId1").text("Recent Exam - Ranks");
    //	$("#testModeId1").text(titleCase(jsonObjExamResults.testType));
    $("#campusRankId").text(jsonObjExamResults.campusRank);
    $("#stateRankId").text(jsonObjExamResults.stateRank);
    $("#airRankId").text(jsonObjExamResults.allIndiaRank);
    $("#projectedRankId").text(jsonObjExamResults.prjectedRank);
  }

  convertDateToStringFormat(testDate: any) {
    var dd = String(testDate.getDate()).padStart(2, '0');
    var mm = String(testDate.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = testDate.getFullYear();

    var examDateFormat = dd + '/' + mm + '/' + yyyy;
    return examDateFormat;
  }


  titleCase(str: any) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  }
  allTestResults(testType: any) {
    this.progressReportOverlay(0);
    this.btnTestCode_TestTypeList2 = testType;
    this.admNo = localStorage.getItem('studentUniqueRefNo')
    this.showTable = false;
    this.service.getTestTypeWiseExamResults(this.scaitsWebServiceUrl, testType, this.admNo).subscribe((res: any) => {
      this.dataToSend = res;
      this.progressReportOverlay(1);
      console.log('dataToSend', this.dataToSend);
      this.showTable = true;


      // if (res) {
      //   this.testTypeExamResultsList = res.studentMarks;
      //   console.log(this.admNo);


      //   const tbMarksTable = document.createElement('table');
      //   $(tbMarksTable).attr('id', "testTypeExamResultsTable");
      //   $(tbMarksTable).attr('data-sort', 'asc');
      //   $(tbMarksTable).addClass('table table-bordered keeptogether myStyle');

      //   // Add table headers
      //   const mpcHeaders = [
      //     'Test Code', 'Test Date', 'Total', 'Total Max Marks',
      //     'Maths', 'Math Max Marks', 'Top Maths', 'Avg Maths', 'M Rank',
      //     'Physics', 'Phy Max Marks', 'Top Physics', 'Avg Physics', 'P Rank',
      //     'Chemistry', 'Che Max Marks', 'Top Chem', 'Avg Chem', 'C Rank',
      //     'Section Rank', 'Campus Rank', 'State Rank'
      //   ];

      //   const bipcHeaders = [
      //     'Test Code', 'Test Date', 'Total', 'Total Max Marks',
      //     'Botany', 'Bot Max Marks', 'Top Botany', 'Avg Botany', 'B Rank',
      //     'Physics', 'Phy Max Marks', 'Top Physics', 'Avg Physics', 'P Rank',
      //     'Chemistry', 'Che Max Marks', 'Top Chem', 'Avg Chem', 'C Rank',
      //     'Section Rank', 'Campus Rank', 'State Rank'
      //   ];

      //   // Create thead and tbody
      //   const thead = document.createElement('thead');
      //   const tbody = document.createElement('tbody');
      //   $(tbMarksTable).append(thead);
      //   $(tbMarksTable).append(tbody);

      //   // Use strict equality for checking the group
      //   if (this.testTypeExamResultsList[0].group === "BIPC") {
      //     let resultsHeader = "<tr>";
      //     for (let i = 0; i < bipcHeaders.length; i++) {
      //       resultsHeader += `<th class='table_hd table-danger txt_align'>${bipcHeaders[i]}</th>`;
      //     }
      //     resultsHeader += "</tr>";
      //     $(thead).append(resultsHeader);

      //     this.testTypeExamResultsList.forEach((testResult: any) => {
      //       let resultBody = "<tr>";
      //       resultBody += `<td>${testResult.testCode}</td>`;
      //       resultBody += `<td>${testResult.testDate}</td>`;
      //       resultBody += `<td>${testResult.total}</td>`;
      //       resultBody += `<td>${testResult.totalMaxMarks}</td>`;
      //       resultBody += `<td>${testResult.botany}</td>`;
      //       resultBody += `<td>${testResult.botMaxMarks}</td>`;
      //       resultBody += `<td>${testResult.topBot}</td>`;
      //       resultBody += `<td>${testResult.avgBot}</td>`;
      //       resultBody += `<td>${testResult.bRank}</td>`;
      //       resultBody += `<td>${testResult.physics}</td>`;
      //       resultBody += `<td>${testResult.phyMaxMarks}</td>`;
      //       resultBody += `<td>${testResult.topPhy}</td>`;
      //       resultBody += `<td>${testResult.avgPhy}</td>`;
      //       resultBody += `<td>${testResult.pRank}</td>`;
      //       resultBody += `<td>${testResult.chemistry}</td>`;
      //       resultBody += `<td>${testResult.cheMaxMarks}</td>`;
      //       resultBody += `<td>${testResult.topChem}</td>`;
      //       resultBody += `<td>${testResult.avgChem}</td>`;
      //       resultBody += `<td>${testResult.cRank}</td>`;
      //       resultBody += `<td>${testResult.secRank}</td>`;
      //       resultBody += `<td>${testResult.campusRank}</td>`;
      //       resultBody += `<td>${testResult.stateRank}</td>`;
      //       resultBody += "</tr>";

      //       $(tbody).append(resultBody);
      //     });
      //   } else if (this.testTypeExamResultsList[0].group === "MPC") {
      //     let resultsHeader = "<tr>";
      //     for (let i = 0; i < mpcHeaders.length; i++) {
      //       resultsHeader += `<th class='table_hd table-danger txt_align'>${mpcHeaders[i]}</th>`;
      //     }
      //     resultsHeader += "</tr>";
      //     $(thead).append(resultsHeader);

      //     this.testTypeExamResultsList.forEach((testResult: any) => {
      //       let resultBody = "<tr>";
      //       resultBody += `<td>${testResult.testCode}</td>`;
      //       resultBody += `<td>${testResult.testDate}</td>`;
      //       resultBody += `<td>${testResult.total}</td>`;
      //       resultBody += `<td>${testResult.totalMaxMarks}</td>`;
      //       resultBody += `<td>${testResult.maths}</td>`;
      //       resultBody += `<td>${testResult.mathMaxMarks}</td>`;
      //       resultBody += `<td>${testResult.topMaths}</td>`;
      //       resultBody += `<td>${testResult.avgMaths}</td>`;
      //       resultBody += `<td>${testResult.mRank}</td>`;
      //       resultBody += `<td>${testResult.physics}</td>`;
      //       resultBody += `<td>${testResult.phyMaxMarks}</td>`;
      //       resultBody += `<td>${testResult.topPhy}</td>`;
      //       resultBody += `<td>${testResult.avgPhy}</td>`;
      //       resultBody += `<td>${testResult.pRank}</td>`;
      //       resultBody += `<td>${testResult.chemistry}</td>`;
      //       resultBody += `<td>${testResult.cheMaxMarks}</td>`;
      //       resultBody += `<td>${testResult.topChem}</td>`;
      //       resultBody += `<td>${testResult.avgChem}</td>`;
      //       resultBody += `<td>${testResult.cRank}</td>`;
      //       resultBody += `<td>${testResult.secRank}</td>`;
      //       resultBody += `<td>${testResult.campusRank}</td>`;
      //       resultBody += `<td>${testResult.stateRank}</td>`;
      //       resultBody += "</tr>";

      //       $(tbody).append(resultBody);
      //     });
      //   }
      
      //   // Append the table to the container

      //   const tableContainer = document.getElementById("allTestResultsTable");
      //   $(tableContainer).empty();
      //   $(tableContainer).append(tbMarksTable);
      // }

    });
  }

  changetab(tab: any) {
    const progressReport = document.getElementById("progressReport");
    const tableContainer = document.getElementById("allTestResults");
    const tab1 = document.getElementById("button1");
    const tab2 = document.getElementById("button2");
    if (tab == "tab1") {
      progressReport!.style.display = "flex";
      tab1!.style.backgroundColor = "#023E8A";
      tab1!.style.color = "white";
      tableContainer!.style.display = "none"
      tab2!.style.backgroundColor = "white";
      tab2!.style.color = "#023E8A";
      this.latestResults()
    }
    else if (tab == "tab2") {
      progressReport!.style.display = "none";
      tab1!.style.backgroundColor = "white";
      tab1!.style.color = "#023E8A";
      tableContainer!.style.display = "flex"
      tab2!.style.backgroundColor = "#023E8A";
      tab2!.style.color = "white";
      this.allTestResults("WEEK-END");
    }

  }
  getBanners(group:any)
  {
    this.service.getBanners(this.scaitsWebServiceUrl,this.admNo).subscribe((res:any)=>{
      if(group=="M.P.C"){
        const topImage = document.getElementById("imgHeaderId") as HTMLImageElement;
      topImage.src = res[0].bannerUrl;

      const bottomImage = document.getElementById("imgFooterId") as HTMLImageElement;
      bottomImage.src = res[1].bannerUrl;
      }
      else if(group=="BI.P.C"){
        const topImage = document.getElementById("imgHeaderId") as HTMLImageElement;
      topImage.src = res[0].bannerUrl;

      const bottomImage = document.getElementById("imgFooterId") as HTMLImageElement;
      bottomImage.src = res[0].bannerUrl;
      }
      
    });
  }
}
